import * as THREE from 'three';
import {
    TouchJoyStick
} from './touch-joystick';
import {
    visualizeLog
} from './utils';


export class Inputs {

    clock = new THREE.Clock();

    moveForward = false;
    moveBackward = false;
    moveLeft = false;
    moveRight = false;
    sprint = false;
    canJump = false;

    velocity = new THREE.Vector3();
    direction = new THREE.Vector3();

    isTouch = false;
    mobileX = 0;
    mobileZ = 0;

    constructor(touch = false) {
        // handle keyboard events
        document.addEventListener('keydown', e => this.onKeyDown(e));
        document.addEventListener('keyup', e => this.onKeyUp(e));

        if (touch) {

            const jumpButton = document.getElementById('jumpButton');

            if (jumpButton) {
                jumpButton.style.display = 'block';

                jumpButton.addEventListener('touchstart', e => {
                    e.preventDefault();
                    e.stopPropagation()
                    visualizeLog(`Jump`)
                    this.jump()
                });

                jumpButton.addEventListener('click', (e => {
                    e.preventDefault();
                    e.stopPropagation()
                    visualizeLog(`Jump`)
                    this.jump()
                }));
            }

            this.isTouch = true;

            setTimeout( () => {

                new TouchJoyStick('joyDiv', {}, (stickData) => {

                    this.clear()
    
                    this.sprint = Math.abs(stickData.x) > 75 || Math.abs(stickData.y) > 75;
    
                    this.direction.z = stickData.y;
                    this.direction.x = stickData.x;
                    this.direction.normalize();
    
                    switch (stickData.cardinalDirection) {
                        case 'N':
                            this.moveForward = true;
                            break;
                        case 'NE':
                            this.moveForward = true;
                            this.moveRight = true;
                            break;
                        case 'E':
                            this.moveRight = true;
                            break;
                        case 'SE':
                            this.moveBackward = true;
                            this.moveRight = true;
                            break;
                        case 'S':
                            this.moveBackward = true;
                            break;
                        case 'SW':
                            this.moveBackward = true;
                            this.moveLeft = true;
                            break;
                        case 'W':
                            this.moveLeft = true;
                            break;
                        case 'NW':
                            this.moveLeft = true;
                            this.moveForward = true;
                            break;
                        case 'C':
                            this.clear();
                            break;
                    }
    
                });

            }, 1000 );
            
        }
    }

    onKeyUp(event) {

        if (this.clock.running && !(this.moveForward || this.moveLeft || this.moveLeft || this.moveRight || this.sprint)) {
            this.clock.stop();
        }

        switch (event.code) {
            case 'ArrowUp':
            case 'KeyW':
                this.moveForward = false;
                break;

            case 'ArrowLeft':
            case 'KeyA':
                this.moveLeft = false;
                break;

            case 'ArrowDown':
            case 'KeyS':
                this.moveBackward = false;
                break;

            case 'ArrowRight':
            case 'KeyD':
                this.moveRight = false;
                break;

            case 'ShiftLeft':
            case 'ShiftRight':
                this.sprint = false;
                break;
        }
    };

    onKeyDown(event) {

        if (!this.clock.running) {
            this.clock.start();
        }

        switch (event.code) {

            case 'ArrowUp':
            case 'KeyW':
                this.moveForward = true;
                break;

            case 'ArrowLeft':
            case 'KeyA':
                this.moveLeft = true;
                break;

            case 'ArrowDown':
            case 'KeyS':
                this.moveBackward = true;
                break;

            case 'ArrowRight':
            case 'KeyD':
                this.moveRight = true;
                break;

            case 'Space':
                if (this.canJump === true) this.velocity.y += 30;
                this.canJump = false;
                break;

            case 'ShiftLeft':
            case 'ShiftRight':
                this.sprint = true;
                break;

        }
    }

    jump() {
        if (this.canJump === true) this.velocity.y += 30;
        this.canJump = false;
    }

    clear() {
        this.moveForward = false;
        this.moveBackward = false;
        this.moveLeft = false;
        this.moveRight = false;
        this.sprint = false;
    }

}